import { Navigate } from 'react-router';
import { resolveLocale } from '../shared/i18n/resolve-locale';
import { readPreferences } from '../shared/storage/preferences';

export function RootRedirect() {
  const locale = resolveLocale({
    saved: readPreferences().locale,
    browserLanguages: navigator.languages ?? [],
  });
  return <Navigate to={`/${locale}/`} replace />;
}
